import React, { createContext } from 'react';
import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import useTheme from './hooks/useTheme';
import { themesOptions, baseOptions } from '../Global/theme';
import { ThemeOption } from '../Global/theme/index';
import { THEMES } from '../Global/constants';

const ThemeContext = createContext();

function ThemeProviderr({ children }) {
  const { theme, changeTheme } = useTheme();
  const themeOptions = themesOptions[theme ? THEMES.DARK : THEMES.LIGHT];
  const appliedTheme = createTheme(baseOptions, themeOptions);
  // console.log(appliedTheme)
  // console.log(theme)

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      <ThemeProvider theme={appliedTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}
export { ThemeContext, ThemeProviderr };
